export default class ValidatorRegistry {
    private validator: Record<string, any>;

    constructor() {
        this.validator = {};
    }

    add(validator, name: string = validator.name) {
        this.validator[name] = validator;
    }

    remove(name: string) {
        delete this.validator[name];
    }

    run(name: string, params) {
        if (!(name in this.validator)) throw new Error(`Validator '${name}' is not found!`);
        return this.validator[name](...params);
    }
}
